import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { User, Check, X } from "lucide-react";

interface AvatarConsentModalProps {
  isOpen: boolean;
  onClose: () => void;
  avatarUrl: string | null;
  username: string;
  onAccept: () => void;
  onDecline: () => void;
}

const AvatarConsentModal = ({
  isOpen,
  onClose,
  avatarUrl,
  username,
  onAccept,
  onDecline,
}: AvatarConsentModalProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleAccept = async () => {
    setIsLoading(true);
    await onAccept();
    setIsLoading(false);
    onClose();
  };

  const handleDecline = async () => {
    setIsLoading(true);
    await onDecline();
    setIsLoading(false);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Zdjęcie profilowe</DialogTitle>
          <DialogDescription>
            Czy chcesz użyć zdjęcia z Twojego konta Google/Apple jako avatara?
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col items-center gap-4 py-4">
          {avatarUrl && (
            <Avatar className="w-24 h-24 border-2 border-primary/20">
              <AvatarImage src={avatarUrl} alt={username} />
              <AvatarFallback>
                <User className="w-12 h-12 text-muted-foreground" />
              </AvatarFallback>
            </Avatar>
          )}
          <p className="text-sm text-muted-foreground text-center">
            Możesz zmienić swoje zdjęcie później w Panelu użytkownika.
          </p>
        </div>

        <DialogFooter className="flex gap-2 sm:gap-0">
          <Button
            variant="outline"
            onClick={handleDecline}
            disabled={isLoading}
            className="gap-2"
          >
            <X className="w-4 h-4" />
            Nie, dziękuję
          </Button>
          <Button
            onClick={handleAccept}
            disabled={isLoading}
            className="gap-2"
          >
            <Check className="w-4 h-4" />
            Tak, użyj tego zdjęcia
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AvatarConsentModal;
